module.exports = __webpack_public_path__ + "img/background6.d598a486.jpg";